import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import {
  AppDataService,
  MerchantUserService,
  ConfigService,
} from 'app/services';
import {
  MerchantStatusEnum,
  RootMenuEnum,
  XpressUserRoleEnum,
} from 'app/models';
import { MenuHomeEnum } from 'app/components/home';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogComponent } from 'app/components/merchant/merchant-confirm-onboarding/message-dialog/message-dialog.component';

@Component({
  selector: 'partner-dashboard-switch',
  templateUrl: './partner-dashboard-switch.component.html',
  styleUrls: ['./partner-dashboard-switch.component.scss'],
  providers: [MessageService],
})
export class PartnerDashboardSwitchComponent implements OnInit {
  public rootMenuEnum = RootMenuEnum;

  public containerName: string = '';

  public merchanUser: any = null;

  public menuEnum = MenuHomeEnum;
  public activeMenu: MenuHomeEnum = MenuHomeEnum.PartnerDashboard;

  public menuPermissionActive!: string;

  constructor(
    private messageService: MessageService,
    public appData: AppDataService,
    public merchantUserService: MerchantUserService,
    public configService: ConfigService,
    private dialog: MatDialog
  ) {}

	ngOnInit(): void {
    if (this.appData.xpressUserRoleId === XpressUserRoleEnum.Merchant && this.appData.authData.roleId !== XpressUserRoleEnum.TourOperator+'') {
      this.getMerchantUserAndMerchant();
    }
  }

  public getMerchantUserAndMerchant() {
    const dto = {
      MerchantUserId: +this.appData.authData.MerchantUserId,
    };

    this.merchantUserService
      .getMerchantUserAndMerchantForConfirmed(dto, this.messageService)
      .then((data) => {
        if (!data) {
          return;
        }

        if (!data.Success) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: data.ErrorMessage,
          });
          return;
        }

        this.merchanUser = data;

        this.appData.merchanUserSource.next(this.merchanUser);

        if (this.merchanUser.MerchantStatus === MerchantStatusEnum.Activated) {
          this.containerName = 'partner-dashboard-root';
        } else if (
          this.merchanUser.MerchantStatus >= MerchantStatusEnum.Sent &&
          this.merchanUser.MerchantStatus <=
            MerchantStatusEnum.ForPartnerSignature
        ) {
          this.containerName = 'merchant-confirm-onboarding';
        } else if (
          this.merchanUser.MerchantStatus >= MerchantStatusEnum.StoreCreation &&
          this.merchanUser.MerchantStatus <=
            MerchantStatusEnum.MerchantStoreSubmitted
        ) {
          this.containerName = 'merchant-store-onboarding';
        } else if (
          this.merchanUser.MerchantStatus === MerchantStatusEnum.WelcomePage
        ) {
          this.dialog.open(MessageDialogComponent, {
            width: '70%',
            maxWidth: '1000px',
            disableClose: true,
            data: this.merchanUser,
          });
          this.containerName = '';
        }

        // TODO: FINAL REVIEW
      });
  }

  public clickMenu(menuPermissionActive: string, menu: MenuHomeEnum) {
    this.menuPermissionActive = menuPermissionActive;
    this.activeMenu = menu;
  }
}
